import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const MessageBubble = ({ message, isMe, senderName, currentUserRole, onDeleteClick }) => {
  const canDelete = currentUserRole === 'ADMIN' && isMe && onDeleteClick;
  
  const handleBubbleClick = () => {
    if (canDelete) {
      onDeleteClick(message.id);
    }
  };
  const showSenderName = message?.showSenderName ?? (!isMe && !!senderName);
  const showTail = message?.showTail ?? true;
  const bubbleSpacing = message?.showTime ? 1.4 : 0.6;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isMe ? 'flex-end' : 'flex-start',
        mb: bubbleSpacing,
      }}
    >
      {showSenderName && senderName && (
        <Typography variant="body2" sx={{ mb: 0.5, color: 'text.primary', fontWeight: 500 }}>
          {senderName}
        </Typography>
      )}

      <Box
        sx={{
          display: 'flex',
          maxWidth: '85%',
          flexDirection: isMe ? 'row-reverse' : 'row',
          alignItems: 'flex-end',
          gap: 0.5,
        }}
      >
        <Paper
          elevation={0}
          onClick={handleBubbleClick}
          sx={{
            p: 1.5,
            bgcolor: isMe ? 'primary.main' : '#F2F3F7',
            color: isMe ? 'primary.contrastText' : '#333',
            position: 'relative',
            borderRadius: 2,
            borderTopLeftRadius: isMe ? 2 : showTail ? 0.75 : 2,
            borderTopRightRadius: isMe ? (showTail ? 0.75 : 2) : 2,
            borderBottomLeftRadius: 2,
            borderBottomRightRadius: 2,
            cursor: canDelete ? 'pointer' : 'default',
            transition: canDelete ? 'opacity 0.2s' : 'none',
            '&:hover': canDelete ? {
              opacity: 0.9,
            } : {},
            ...(showTail
              ? {
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 8,
                    width: 10,
                    height: 10,
                    bgcolor: isMe ? 'primary.main' : '#F2F3F7',
                    transform: 'rotate(45deg)',
                    ...(isMe
                      ? { right: -4, borderBottomRightRadius: 2 }
                      : { left: -4, borderBottomLeftRadius: 2 }),
                  },
                }
              : {}),
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              whiteSpace: 'pre-line', 
              wordBreak: 'break-all',
              lineHeight: 1.5
            }}
          >
            {message?.content || ''}
          </Typography>
        </Paper>

        {message?.showTime && (
          <Typography
            variant="caption"
            sx={{
              color: '#999',
              fontSize: 11,
              mb: 0,
              whiteSpace: 'nowrap',
            }}
          >
            {message?.time || ''}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default MessageBubble;
